/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-cycle */
import React, { useRef, useState, useEffect } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Sort,
  Filter,
  Resize,
  Edit,
  Toolbar,
  LazyLoadGroup,
  Group,
  Page,
  PdfExport,
  ExcelExport,
  ForeignKey,
} from '@syncfusion/ej2-react-grids';
import { ToolbarComponent, ItemsDirective, ItemDirective, AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { TextBoxComponent, UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { Query } from '@syncfusion/ej2-data';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import { Header, Events } from '../components';
import armband from '../data/watchsketch.png';

import { inv2Grid } from '../data/dummy';
import './inventory.css';
import './Zackat.css';

const Inventory2 = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');

  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=inventory2');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);

  const { REACT_APP_API_ENDPOINT } = process.env;
  const valuerules = { required: true };
  const [enableEvents, setEvents] = useState(true);
  const add = { text: 'Add', tooltipText: 'Add Associate', prefixIcon: 'e-add', id: 'add', disabled: false };
  const toolbarOptions = ['Search', add, 'Delete', 'PdfExport', 'ExcelExport'];

  const [groups, setGroups] = useState([]);
  const [sortOptions, setSortColumns] = useState({});
  const [reload, setReload] = useState(false);
  const [inventoryid, setInventoryId] = useState('');
  const [selCharger, setCharger] = useState('');
  const [selVersion, setVersion] = useState('');
  const [selRRSP, setRRSP] = useState('');
  const [selUploadOrganization, setUploadOrganization] = useState('');
  const [selDevice, setDevice] = useState('');
  const [selAssociate, setAssociate] = useState('');
  const [selInventoryStatus, setInventoryStatus] = useState('');
  const [selIMEI, setIMEI] = useState('');
  const [selMSN, setMSN] = useState('');
  const [selStatus, setStatus] = useState('');
  const [selBattery, setBattery] = useState('');
  const [dataChanged, setDataChanged] = useState(false);
  const [inventory, setInventory] = useState(null);
  const [selOrganization, setOrganization] = useState('');
  const orgData = [];
  const associateData = [];
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  let grid;
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  useEffect(() => {
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Create')) {
      setCrudCreate(true);
    }
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Update')) {
      setCrudUpdate(true);
    }
    if (data.role && data.role.inventory && data.role.inventory.permissions.includes('Delete')) {
      setCrudDelete(true);
    }
  }, [data]);

  const onToolbarChange = (args) => {
    if (grid) {
      const selectedRow = grid.getSelectedRecords()[0];
      if (args.target.textContent === 'Update') {
        grid.endEdit();
      }
      if (args.target.textContent === 'Edit') {
        grid.startEdit();
      }
      if (args.target.textContent === 'Delete') {
        grid.deleteRecord(selectedRow);
      }
      if (args.target.textContent === 'Add') {
        grid.addRecord();
      }
      if (args.target.textContent === 'Events') {
        navigate(`../events?device=${selectedRow.device}`);
      }
      if (args.target.textContent === 'PDF Export') {
        const properties = {
          fileName: `PDFExport_Inventory_${new Date().toISOString()}.pdf`,
          pageOrientation: 'Landscape',
        };
        grid.pdfExport(properties);
      }
      if (args.target.textContent === 'Excel Export') {
        const properties = {
          fileName: `ExcelExport_Inventory_${new Date().toISOString()}.xlsx`,
        };
        grid.excelExport(properties);
      }
    }
  };

  const actionData = [
    { text: 'Not specified', value: 'na' },
    { text: 'FOTA', value: 'fota' },
    { text: 'Locate', value: 'locate' },
    { text: 'Reset', value: 'reset' },
    { text: 'SMS', value: 'sms' },
    { text: 'Rehome', value: 'rehome' },
  ];
  const [selectedOption, setSelectedOption] = useState(actionData[0]);
  const audioData = [
    { text: 'Not specified', value: 'na' },
  ];
  const [selectedAudioOption, setSelectedAudioOption] = useState(audioData[0]);
  function recordingDevice(e) {
    if (!grid) {
      return;
    }
    if (e.target.itemData.value === 'na') {
      return;
    }
    setSelectedAudioOption(e.target.itemData.value);

    const selectedRecords = grid.getSelectedRecords();
    if (!selectedRecords || selectedRecords.length === 0) {
      return;
    }
    const b = selectedRecords[0];
    if (!confirm(`Send recording ${e.target.itemData.text} to ${b.name}?`)) {
      return;
    }
    const message = `"audio": "${e.target.itemData.value}"`;
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        DialogUtility.alert('audio request sent');
        setSelectedAudioOption('na');
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function smsDevice(e) {
    if (!grid) {
      return;
    }
    if (!e) {
      DialogUtility.alert('No device selected!');
      return;
    }
    const selectedRecords = grid.getSelectedRecords();
    if (!selectedRecords || selectedRecords.length === 0) {
      DialogUtility.alert('Please select a Device!');
      return;
    }
    const b = selectedRecords[0];
    const cmd = e.target.itemData.value;
    setSelectedOption(cmd);
    let message = '';
    if (cmd === 'na') {
      DialogUtility.alert('No command supplied');
      return;
    }
    if (b.device === '') {
      DialogUtility.alert('No device selected!');
      return;
    }
    let name = '';
    if (inventory.associate && inventory.associate.length > 0) {
      name = `(${inventory.associate})`;
    }
    if (cmd === 'reset') {
      message = prompt(`Restart device ${b.device} ${name} or put device to sleep?`, 'restart');
      if (!message || message.length === 0) {
        return;
      }
      if (message.toLocaleLowerCase() === 'restart') {
        message = '"reset":"restart"';
      } else if (message.toLocaleLowerCase() === 'sleep') {
        message = '"reset":"sleep"';
      } else {
        return;
      }
    } else if (cmd === 'fota') {
      if (!confirm(`Send a FOTA request to ${b.name}`)) {
        return;
      }
      message = '"fota":"ind"';
    } else if (cmd === 'locate') {
      message = '"locate":"query"';
      if (!confirm(`Send a LOCATE request to ${b.name}`)) {
        return;
      }
    } else if (cmd === 'rehome') {
      message = prompt(`ReHome device ${b.device} (${b.name}) production, staging or development?`, 'production');
      if (!message || message.length === 0) {
        return;
      }
      switch (message.toLocaleLowerCase()) {
        case 'production':
          message = '"srvr":{"url":"bio.zackatlabs.com", "port": "10900"}';
          break;
        case 'staging':
          message = '"srvr":{"url":"biometric.zackatlabs.com", "port": "10900"}';
          break;
        case 'development':
          message = '"srvr":{"url":"biometric.zackat.com", "port": "10900"}';
          break;
        default:
          message = `"srvr":{"url":"${message}", "port": "10900"}`;
          break;
      }
    } else {
      message = prompt(`What SMS would you like to send to ${b.device} (${b.name})?`, '');
    }
    if (!message || message.length === 0) {
      return;
    }
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        DialogUtility.alert(`${cmd} request sent`);
        setSelectedOption('na');
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  }
  const actionComponent = () => (
    <DropDownListComponent id="ddlelement" dataSource={actionData} placeholder="Device Action" value={selectedOption} onChange={smsDevice} />
  );
  const audioComponent = () => (
    <DropDownListComponent dataSource={audioData} placeholder="Send Recording" value={selectedAudioOption} onChange={recordingDevice} />
  );

  useEffect(() => {
    if (grid) {
      const selectedRecords = grid.getSelectedRecords();
      if (selectedRecords && selectedRecords.length === 1) {
        setInventoryId(selectedRecords[0]._id);
        setEvents(false);
      } else {
        setInventoryId('');
        setEvents(true);
      }
    } else {
      setInventoryId('');
      setEvents(true);
    }
  }, [dataChanged]);
  const saveProfile = () => {
    if (inventory.organizationid !== selOrganization) {
      const result = orgData.find(({ id }) => id === selOrganization);
      if (!confirm(`Would you like to move this Inventory ${inventory.device} from ${inventory.organization} to ${result.value}`)) {
        return;
      }
      inventory.organizationid = selOrganization;
      inventory.organization = result.value;
    }
    if (selDevice.length > 0 && (selDevice.length < 19 || selDevice.length > 20)) {
      DialogUtility.alert('Please provide a valid device for the inventory');
      return;
    }
    inventory.msn = selMSN;
    inventory.device = selDevice;
    inventory.imei = selIMEI;
    if (!confirm(`Would you like to move this Inventory ${inventory.device} ${inventory.msn} ${inventory._id}`)) {
      return;
    }
    const inv = [];
    inv.push(inventory);
    fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(inv),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        DialogUtility.alert('Profile saved');
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during Update!');
      });
  };

  const addProfile = () => {
    const result = orgData.find(({ id }) => id === selOrganization);
    const newinventory = {};
    newinventory.organizationid = selOrganization;
    if (!result || !result.value || result.value.length === 0) {
      DialogUtility.alert('Please select an Organization!');
      return;
    }
    newinventory.organization = result.value;
    if (selIMEI.length > 0 && selIMEI.length >= 15 && selIMEI.length <= 16) {
      newinventory.name = selIMEI;
    } else {
      DialogUtility.alert(`Invalid IMEI specified ${selIMEI}`);
      return;
    }
    if (selDevice.length >= 19 && selDevice.length <= 20) {
      newinventory.device = selDevice;
    } else {
      DialogUtility.alert(`Invalid Device specified ${selDevice}`);
      return;
    }
    newinventory.msn = selMSN;
    newinventory.imei = selIMEI;
    newinventory.simstatus = {};
    newinventory.status = 'stock';
    newinventory.associate = '';
    newinventory.associateid = '';
    const inv = [];
    inv.push(newinventory);
    if (!confirm(`Add Inventory ${selDevice} to ${result.value}`)) {
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(inv),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson._id) {
          newinventory._id = responseJson._id;
          setInventoryId(newinventory._id);
          setReload(!reload);
        }
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        }
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during New Inventory Insert!');
      });
  };

  const cancelProfile = () => {
    setInventoryId('');
  };
  function rowClicked() {
    // setEvents(false);
    setInventory(null);
    setDataChanged(!dataChanged);
  }
  const groupOptions = {
    enableLazyLoading: false,
    columns: groups,
  };

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = 0;
    // fetch data
    const dataFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/inventory?${query}&abbrev=true`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      if (mydata.user && mydata.user.preferences && mydata.user.preferences.inventory2) {
        if (mydata.user.preferences.inventory2.group) {
          setGroups(mydata.user.preferences.inventory2.group);
        } else {
          setGroups(['organizationid']);
        }
        if (mydata.user.preferences.inventory2.sort && mydata.user.preferences.inventory2.sort[0].direction) {
          const mysortedColumns = { columns: mydata.user.preferences.inventory2.sort };
          setSortColumns(mysortedColumns);
        }
      } else {
        setGroups(['organizationid']);
      }
      // set state when the data received
      setData(mydata);
      setLoading(false);
    };
    dataFetch();
  }, [reload]);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const inventoryFetch = async () => {
      if (inventoryid !== '' && inventoryid !== 'add_inventory') {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/inventory?${query}&inventoryid=${inventoryid}`;
        if (!usr.loggedIn) {
          navigate('/login');
          return;
        }
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json();
        if (mydata && mydata._id) {
          setStatus(`${mydata.status ? mydata.status : ''}`);
          setBattery(`${mydata.battery ? mydata.battery : ''}`);
          setDevice(`${mydata.device ? mydata.device : ''}`);
          setAssociate(`${mydata.associate ? mydata.associate : ''}`);
          setVersion(`${mydata.version ? mydata.version : ''}`);
          setCharger(`${mydata.charger ? mydata.charger : ''}`);
          setRRSP(`${mydata.rssi ? mydata.rssi : ''}`);
          setIMEI(`${mydata.imei ? mydata.imei : ''}`);
          setMSN(`${mydata.msn ? mydata.msn : ''}`);
          setOrganization(mydata.organizationid ? mydata.organizationid : null);
          setInventoryStatus(`Status:${mydata.status.toUpperCase()}\r\nVersion:${mydata.version}\r\nBattery:${mydata.battery}\r\nCharger:${mydata.charger}\r\nRRSP:${mydata.rssi}\r\n`);
          setInventory(mydata);
        }
      }
    };
    inventoryFetch();
  }, [inventoryid]);

  if (loading) {
    return <p>Loading... </p>;
  }
  if (data.organization) {
    data.organization.forEach((element) => {
      orgData.push({ id: element._id, value: element.title });
    });
  }
  if (data.associates) {
    data.associates.forEach((element) => {
      associateData.push({ id: element._id, value: element.name });
    });
  }

  if (data.role && data.role.inventory && !data.role.inventory.permissions.includes('Read')) {
    return <p>Not authorized...</p>;
  }
  const editing = {
    allowEditing: crudUpdate,
    allowAdding: crudCreate,
    allowDeleting: crudDelete,
    showConfirmDialog: false,
    showDeleteConfirmDialog: true,
    allowEditOnDblClick: false,
    mode: 'Dialog',
  };
  function setUserPreferences(pref, val) {
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.inventory2) {
      data.user.preferences.inventory2 = {};
    }
    if (pref === 'group') {
      data.user.preferences.inventory2 = { group: val, sort: data.user.preferences.inventory2.sort };
    } else if (pref === 'sort') {
      data.user.preferences.inventory2 = { group: data.user.preferences.inventory2.group, sort: val };
    }
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        }
      })
      .catch(() => {
      });
  }
  const actionBegin = (args) => {
    if (args.requestType === 'ungrouping' || args.requestType === 'grouping') {
      const index = groups.indexOf(args.columnName);
      if (index > -1 && args.requestType === 'ungrouping') { // only splice array when item is found
        groups.splice(index, 1); // 2nd parameter means remove one item only
      } else if (index === -1 && args.requestType === 'grouping') { // only splice array when item is found
        groups.push(args.columnName); // 2nd parameter means remove one item only
      }
      setUserPreferences('group', groups);
    } else if (args.requestType === 'sorting') {
      setUserPreferences('sort', [{ field: args.columnName, direction: args.direction }]);
    }
  };
  const associates = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.associates,
      fields: { value: '_id', text: 'name' },
      query: new Query(),
    },
  };

  const actionComplete = (args) => {
    const editedData = args.data;
    /** Set initial Focus */
    if (args.requestType === 'beginEdit') {
      // eslint-disable-next-line prefer-destructuring
      const dialog = args.dialog;
      dialog.width = '400px';
      dialog.header = `Details of ${args.rowData.device}`;
    }
    if (args.requestType === 'save' && args.form && args.action === 'add') {
      if (editedData && editedData.device.length >= 19 && editedData.device.length <= 20) {
        if (isNaN(args.data.device)) {
          DialogUtility.alert(`NaN Invalid Device ID ${editedData.device}`);
          args.cancel = true;
          setReload(!reload);
          return;
        }

        // Here you can send the updated data to your server using AJAX call

        editedData.simstatus = { status: 'active' };
        const oresult = orgData.find(({ id }) => id === editedData.organizationid);
        if (!oresult) {
          DialogUtility.alert('Error finding Organization');
          args.cancel = true;
          setReload(!reload);
          return;
        }
        editedData.organization = oresult.value;
        const result = associateData.find(({ id }) => id === editedData.inventoryid);
        if (result) {
          editedData.associate = result.value;
        }
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The default edit operation is cancelled
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              DialogUtility.alert(responseJson.response);
              setReload(!reload);
              args.cancel = true;
            }
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson._id) {
              args.data._id = responseJson._id;
            }
          })
          .catch((error) => {
            setReload(!reload);
            args.cancel = true;
          });
      } else {
        DialogUtility.alert(`Invalid device ID ${args.data.device}`);
        setReload(!reload);
      }
    } else if (args.requestType === 'save' && args.form && args.action === 'edit') {
      if (args.data) {
        const invs = [];
        if (editedData.associateid) {
          const result = associateData.find(({ id }) => id === editedData.inventoryid);
          if (result) {
            editedData.associate = result.value;
          }
        }
        const oresult = orgData.find(({ id }) => id === editedData.organizationid);
        if (!oresult) {
          DialogUtility.alert('Error finding Organization');
          args.cancel = true;
          setReload(!reload);
          return;
        }
        editedData.organization = oresult.value;
        invs.push(editedData);
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(invs),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The default edit operation is cancelled
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              DialogUtility.alert(responseJson.response);
              args.cancel = true;
            }
            // The added/edited data will be saved in the Grid
          })
          .catch(() => {
            args.cancel = true;
          });
      }
    } else if (args.requestType === 'batchsave') {
      if (args.rows && args.rows.length > 0) {
        const invs = [];
        for (let x = 0; x < args.rows.length; x++) {
          invs.push(args.rows[x].data);
        }
        // The default edit operation is cancelled

        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(invs),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              DialogUtility.alert(responseJson.response);
              args.cancel = true;
              setReload(!reload);
            }
          })
          .catch(() => {
            args.cancel = true;
            setReload(!reload);
          });
      }
    } else if (args.requestType === 'delete') {
      let entry = ' this entry?';
      if (args.data.length > 1) {
        entry = ' these entries?';
      }
      if (args.data) {
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/inventory`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              DialogUtility.alert(responseJson.response);
              args.cancel = true;
            }
            setInventoryId('');
            setReload(!reload);
          })
          .catch(() => {
            args.cancel = true;
            setReload(!reload);
          });
      }
    }
  };

  function onFileUpload(args) {
    // add addition data as key-value pair.
    const result = orgData.find(({ id }) => id === selUploadOrganization);
    if (!result || !result.value || result.value === '') {
      DialogUtility.alert('Invalid Organization');
      args.cancel = true;
      return;
    }
    if (!confirm(`Upload to ${result.value}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: selUploadOrganization }];
  }
  let uploadObj;
  const path = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/inventoryremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/inventoryupload`,
  };

  const FilterOptions = {
    type: 'Menu',
  };
  function completeUpload(args) {
    DialogUtility.alert(`Upload completed ${args.fileData[0].status}`);
    setReload(!reload);
  }
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };
  const currentThemeColor = localStorage.getItem('colorMode');
  const clickHandler = (args) => {
    if (grid && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_Inventory_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.pdfExport(properties);
    } else if (grid && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_Inventory_${new Date().toISOString()}.xlsx`,
      };
      grid.excelExport(properties);
    } else if (grid && args.item.properties.text === 'Batch') {
      if (grid.properties.editSettings.properties.mode === 'Dialog') {
        grid.properties.editSettings.properties.mode = 'Batch';
      } else {
        grid.properties.editSettings.properties.mode = 'Dialog';
      }
    } else if (grid && args.item.properties.text === 'Events') {
      const selectedRecords = grid.getSelectedRecords();
      if (!selectedRecords || selectedRecords.length === 0) {
        DialogUtility.alert('Please select a device');
      } else if (selectedRecords && selectedRecords.length === 1) {
        navigate(`../events?device=${selectedRecords[0].device}`);
      }
    } else if (grid && args.item.properties.text === 'Add') {
      setDevice('');
      setIMEI('');
      setMSN('');
      setOrganization(null);
      setInventory(null);
      setInventoryId('add_inventory');
    }
  };
  const orgRule = { required: true };
  const organizations = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: data.organization,
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh">
      <img
        className="w-20"
        src={armband}
        alt="arm band"
      />
      <Header category="Inventory" title="Inventory" />
      <div style={{
        backgroundColor: currentThemeColor,
        textAlign: 'left',
        marginTop: '-40px',
      }}
      >
        <div id="droparea">
          {crudCreate && (
          <div className="control-section accordion-control-section" style={{ width: '45%' }}>
            <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
              <AccordionComponent>
                <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                  <div className="e-input-group">
                    <div className="mt-4"> Import </div>
                  </div>
                  <div className="mt-2 e-input-group">
                    <div>
                      <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selUploadOrganization} onChange={(v) => { setUploadOrganization(v.value); }} />
                    </div>
                    <UploaderComponent
                      id="fileupload"
                      type="file"
                      ref={(uplaod) => { uploadObj = uplaod; }}
                      asyncSettings={path}
                      buttons={buttons}
                      multiple={false}
                      actionComplete={completeUpload}
                      autoUpload={false}
                      uploading={onFileUpload}
                      allowedExtensions=".csv"
                    />
                  </div>
                </div>
              </AccordionComponent>
            </div>
          </div>
          )}
          {!loading && !enableEvents && (
          <div>
            <ToolbarComponent id="toolbar" onClick={onToolbarChange}>
              <ItemsDirective>
                <ItemDirective text="Events" prefixIcon="e-justify" />
                <ItemDirective type="Separator" />
                <ItemDirective template={actionComponent} />
                <ItemDirective type="Separator" />
                {/* <ItemDirective template={audioComponent} />
                <ItemDirective type="Separator" />
                */}
                {/* <ItemDirective template={audioComponent} disabled={enableEvents} />
                <ItemDirective type="Separator" />
                */}
              </ItemsDirective>
            </ToolbarComponent>
          </div>
          )}
        </div>
        <div style={{
          textAlign: 'left',
        }}
        >
          <div className="flex" height="300px">
            <GridComponent
              dataSource={data.inventory}
              enableHover
              allowPaging
              pageSettings={{ pageCount: 5 }}
              toolbar={toolbarOptions}
              editSettings={editing}
              allowSorting
              allowResizing
              allowFiltering={data && data.inventory && data.inventory.length > 0}
              filterSettings={FilterOptions}
              actionComplete={actionComplete}
              actionBegin={actionBegin}
              toolbarClick={clickHandler}
              allowTextWrap
              allowPdfExport
              allowExcelExport
              allowGrouping
              recordClick={rowClicked}
              groupSettings={groupOptions}
              sortSettings={sortOptions}
              ref={(g) => { grid = g; }}
              width="55%"
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="device"
                  headerText="Device"
                  width="80"
                  textAlign="Left"
                  validationRules={valuerules}
                  visible
                />
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                {inv2Grid.map((item, index) => <ColumnDirective key={index} {...item} />)}

                <ColumnDirective
                  field="organizationid"
                  headerText="Organization"
                  width="70"
                  textAlign="Left"
                  editType="dropdownedit"
                  edit={organizations}
                  validationRules={valuerules}
                  visible
                  foreignKeyField="_id"
                  foreignKeyValue="title"
                  dataSource={organizations.params.dataSource}
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Edit, Toolbar, Filter, Sort, Resize, PdfExport, ExcelExport, ForeignKey, LazyLoadGroup, Group]} />
            </GridComponent>
            {inventoryid !== ''
            && (
            <div
              className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh"
              /*
              style={{
                backgroundImage: `url(${armband})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                height: '400px',
                width: '400px',
                opacity: 0.1,
              }}
                */
            >
              <form>
                {inventoryid !== 'add_inventory'
            && (
            <div className="control-section accordion-control-section">
              <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
                <AccordionComponent>
                  <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                    <div className="e-input-group">
                      <div className="mt-4"> Status </div>
                    </div>
                    <div className="mt-2 e-mygrid">
                      <TextBoxComponent className="mt-2" multiline placeholder="" value={selInventoryStatus} title="current status information " disabled readOnly floatLabelType="Auto" onChange={() => { }} />
                    </div>
                  </div>
                </AccordionComponent>
              </div>
            </div>
            )}
                {inventoryid !== 'add_inventory'
            && (
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
              <div className="e-input-group">
                <TextBoxComponent placeholder="Associate" title="Controlled via Associate tab" value={selAssociate} disabled readOnly cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAssociate(v.value); }} />
              </div>
            </div>
            )}
                <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                  <div className="e-input-group">
                    <TextBoxComponent placeholder="IMEI" title="Controlled via Manager tab" value={selIMEI} cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setIMEI(v.value); }} />
                    <TextBoxComponent placeholder="MSN" value={selMSN} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setMSN(v.value); }} />
                  </div>
                </div>

                <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2">
                  <div className="e-input-group">
                    <TextBoxComponent placeholder="Device" value={selDevice} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setDevice(v.value); }} />
                  </div>
                </div>
                <div className="row custom-margin">
                  <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
                    <div className="e-input-group">
                      <DropDownListComponent id="ddlelement" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selOrganization} onChange={(v) => { setOrganization(v.value); }} />
                    </div>
                  </div>
                </div>
              </form>
              {inventoryid !== 'add_inventory' && (
              <div className="col-xs-12 col-sm-12 col-lg-6 col-md-6">
                <ButtonComponent cssClass="e-warning" onClick={cancelProfile}>Cancel</ButtonComponent>
                {crudUpdate && <ButtonComponent style={{ float: 'right' }} cssClass="e-info" onClick={saveProfile}>Save</ButtonComponent>}
              </div>
              )}
              {inventoryid === 'add_inventory' && (
              <div className="col-xs-12 col-sm-12 col-lg-6 col-md-6">
                <ButtonComponent cssClass="e-warning" onClick={cancelProfile}>Cancel</ButtonComponent>
                {crudCreate && <ButtonComponent style={{ float: 'right' }} cssClass="e-success" onClick={addProfile}>Add</ButtonComponent>}
              </div>
              )}
            </div>
            )}
          </div>
        </div>
      </div>
      {inventory && (
      <div className="control-section accordion-control-section" style={{ width: '100%' }}>
        <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
          <AccordionComponent>
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
              <div className="e-input-group">
                <div className="mt-4"> Events </div>
              </div>
              <div>
                <Events props={inventory} />
              </div>
            </div>
          </AccordionComponent>
        </div>
      </div>
      )}
    </div>
  );
};
export default Inventory2;
